import * as types from "./simpleFetchActionTypes";

export function showToast(value) {
	return {
	  type: types.SHOW_TOAST,
	  value,
	};
  }

export function resetToast(value) {
	return {
	  type: types.RESET_TOAST,
	  value,
	};
  }



// WEBPACK FOOTER //
// ./utils/simpleFetchActions.js